import { App } from "vue";
import print from 'vue3-print-nb'

export function setupGlobalDirectives(app: App) {
  app.use(print)
}
